import { useQuery } from "@apollo/client";
import type { Agent } from "@casey/db-types";
import { GET_INTERVIEW_TEMPLATES } from "../gql";

export interface AgentsData {
  agents: {
    nodes: Agent[];
  };
}

export function useAgents() {
  const { data, loading, error, refetch } = useQuery<AgentsData>(
    GET_INTERVIEW_TEMPLATES,
    {
      errorPolicy: "all",
    },
  );

  const templates = data?.agents?.nodes || [];

  return {
    templates,
    loading,
    error,
    refetch,
  };
}
